export default {
  rewardsTimestamp(state) {
    return state.rewardsTimestamp;
  },
  rewards(state) {
    return state.rewards;
  },
  claims(state) {
    return state.claims;
  },
  pendingClaims(state) {
    return state.pendingClaims;
  },
};
